import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../../interfaces/IReduxState";


export const PreviousClassReadSlice = createSlice({
  name: "PreviousClassReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    PreviousClassRead: (state) => {
      state.isLoading = true;
    },
    successPreviousClassRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurePreviousClassRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearPreviousClassRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  PreviousClassRead,
  successPreviousClassRead,
  failurePreviousClassRead,
  clearPreviousClassRead,
} = PreviousClassReadSlice.actions;

export default PreviousClassReadSlice.reducer;
